import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../auth/auth.service';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { EscapeDialogHelper } from '../../../helpers/escape-dialog.helper';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatDivider } from '@angular/material/divider';
import { MatInput } from '@angular/material/input';
import { BrowserAutoFillDisabledDirective } from '../../../directives/browser-auto-fill-disabled.directive';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-password-confirmation',
  templateUrl: './password-confirmation.component.html',
  imports: [
    ReactiveFormsModule,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    BrowserAutoFillDisabledDirective,
    MatError,
    MatDialogActions,
    NgClass,
    MatButton,
    MatDialogClose,
    MatDivider
  ]
})
export class PasswordConfirmationComponent implements OnInit {
  passwordForm: UntypedFormGroup;
  pending = false;

  constructor(
    public dialogRef: MatDialogRef<PasswordConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private auth: AuthService,
    private message: MessagingService,
    private escapeDialogRef: EscapeDialogHelper
  ) {}

  get password() {
    return this.passwordForm.get('password');
  }

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required]]
    });

    this.escapeDialogRef.escapeDialog(this.dialogRef);
  }

  confirm() {
    const username: string = this.data.username;
    const password: string = this.password.value.trim();

    if (username && password) {
      this.pending = true;

      this.auth.login({ username, password }).subscribe(
        () => this.dialogRef.close({ result: 'Confirmed', value: password }),
        (error) => {
          if (error.status === 403) {
            // Auth Provider rejected the credentials
            this.password.setErrors({ notValid: true });
          } else {
            // There was am unexpected problem
            this.message.error('There was a problem checking password. Please try again.');
          }
          this.pending = false;
        }
      );
    } else {
      this.message.error('There was a problem checking password. Please try again.');
    }
  }
}
